import axios from 'axios';
import { APP_VERSION } from '../version';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
  headers: {
  }
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }

    // Get language from localStorage
    const userSettingsStr = localStorage.getItem('userSettings');
    let language = 'en';

    try {
      if (userSettingsStr) {
        const userSettings = JSON.parse(userSettingsStr);
        language = userSettings.language || 'en';
      }
    } catch (error) {
      console.error('Error parsing userSettings:', error);
    }

    // Add language to request data
    if (config.method === 'get') {
      config.params = { ...config.params, language };
    } else if (config.data instanceof FormData) {
      config.data.append('language', language);
    } else {
      config.data = { ...config.data, language };
    }

    // Check if we're in the logout process
    if (localStorage.getItem('logging_out') === 'true') {
      // Skip version checking during logout
      return config;
    }

    // Check if we're reloading due to version change
    const urlParams = new URLSearchParams(window.location.search);
    const reloadParam = urlParams.get('reload');

    if (reloadParam) {
      // Clear the reload parameter from URL
      window.history.pushState({}, '', window.location.pathname);
      // Update version in localStorage
      localStorage.setItem('appVersion', APP_VERSION);
    } else {
      // Check version and reload if needed
      const cachedVersion = localStorage.getItem('appVersion');
      if (cachedVersion !== APP_VERSION) {
        // Force reload with a reload parameter
        window.location.href = window.location.pathname + '?reload=true';
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;